import { FaUsers, FaLightbulb, FaBook, FaHandshake } from "react-icons/fa";
import Card from "../components/Card";
import { Helmet } from "react-helmet";
import { FaFilePdf } from "react-icons/fa";

function Programmes() {
  const pdfs = [
    {
      title: "TechSmart",
      text: "Exploring digital skills and technology-driven opportunities for youth development.",
      file: "/pdfs/techsmart.pdf",
    },
    {
      title: "Too Late",
      text: "Addressing delayed investments in human capital and future growth challenges.",
      file: "/pdfs/toolate.pdf",
    },
    {
      title: "Tomorrow",
      text: "A forward-looking perspective on sustainable prosperity through human capital.",
      file: "/pdfs/tomorrow.pdf",
    },
  ];


  const programmes = [
    {
      icon: <FaUsers />,
      title: "Youth Development Programme",
      body: "This programme supports young people through mentorship, personal growth sessions and guided learning experiences.",
    },
    {
      icon: <FaLightbulb />,
      title: "Leadership Training",
      body: "Participants learn practical leadership values including teamwork, responsibility and effective decision making.",
    },
    {
      icon: <FaBook />,
      title: "Educational Support",
      body: "We encourage continuous learning through seminars, shared resources and educational discussions.",
    },
    {
      icon: <FaHandshake />,
      title: "Community Engagement",
      body: "Community initiatives that promote collaboration, social responsibility and active participation.",
    },
  ];

  const resources = [
    {
      title: "Human Development Reports",
      text: "Research and global reports on human development from the UNDP.",
      link: "https://hdr.undp.org/",
    },
    {
      title: "World Bank Education Resources",
      text: "Articles and research focused on education and human capital development.",
      link: "https://www.worldbank.org/en/topic/education",
    },
    {
      title: "UNICEF Education Materials",
      text: "Learning resources that support youth empowerment and education access.",
      link: "https://www.unicef.org/education",
    },
    {
      title: "Human Development Data Center",
      text: "Global development data and statistics from the UNDP data center.",
      link: "https://hdr.undp.org/data-center",
    },
  ];

  return (
    <>

      <Helmet>
        <title>OGTH Programs – Youth Development & Leadership Training</title>
        <meta
          name="description"
          content="Explore OGTH programs including youth development, leadership training, educational support, and community engagement initiatives for Africa’s future leaders."
        />
        <meta
          name="keywords"
          content="OGTH programs, youth development, leadership training, educational support, community engagement, Africa youth programs, skills development"
        />
        <meta property="og:title" content="OGTH Programs – Youth Development & Leadership Training" />
        <meta property="og:description" content="Explore OGTH programs including youth development, leadership training, educational support, and community engagement initiatives for Africa’s future leaders." />
        <meta property="og:image" content="https://yourdomain.com/path-to-programs-image.jpg" />
        <meta property="og:url" content="https://yourdomain.com/programs" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="bg-gray-50 text-gray-700 font-sans">

        {/* HERO */}
        <div className="bg-brand text-white text-center py-16 px-5">
          <h1 className="text-3xl font-bold mb-3">Our Programmes</h1>

          <p className="max-w-2xl mx-auto opacity-90 text-sm md:text-base">
            OGTH focuses on human capital development through initiatives that support
            learning, leadership growth and community participation. Our programmes
            aim to help individuals build knowledge and skills that contribute
            positively to society.
          </p>
        </div>

        <div className="max-w-6xl mx-auto px-5 py-12">

          {/* PROGRAMMES */}
          <div className="max-w-6xl mx-auto px-5 py-12">
            <h2 className="text-xl font-bold text-center mb-8">Programmes</h2>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
              {programmes.map((item, index) => (
                <Card
                  key={index}
                  icon={item.icon}
                  title={item.title}
                  body={item.body}
                />
              ))}
            </div>
          </div>

          {/* RESOURCES */}
          {/* <div className="mt-16">

          <div className="text-center mb-8">
            <h2 className="text-xl font-bold ">
              Learning Resources
            </h2>
          </div>

          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {resources.map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md transition transform hover:-translate-y-1"
              >
                <h4 className="text-lg font-semibold mb-2">
                  {item.title}
                </h4>

                <p className="text-sm text-gray-600 mb-4">
                  {item.text}
                </p>

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block bg-brand-secondary hover:bg-[#3F8FB6] text-white text-sm px-4 py-2 rounded-md"
                >
                  View Resource
                </a>
              </div>
            ))}
          </div>

        </div> */}

          <div className="text-center mb-8 bg-brand py-16 px-5">
            <h1 className="text-3xl mb-3 text-white font-bold">Learning Resources</h1>
          </div>

          {/* EXTERNAL RESOURCES */}
          <div className="px-6 max-w-7xl mx-auto">
            <h2 className="text-xl font-bold mb-6 text-center">Global Learning Resources</h2>

            <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
              {resources.map((resource, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-md hover:-translate-y-1 transition"
                >
                  <h4 className="text-lg font-semibold mb-2">{resource.title}</h4>
                  <p className="text-sm text-gray-600 mb-4">{resource.text}</p>
                  <a
                    href={resource.link}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-block bg-brand-secondary hover:bg-[#3F8FB6] text-white text-sm px-4 py-2 rounded-md"
                  >
                    View Resource
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* OGTH PUBLICATIONS (YOUR PDFs) */}
          <div className="px-6 max-w-7xl mx-auto mt-16">
            <h2 className="text-xl font-bold mb-6 text-center">OGTH Publications</h2>

            <div className="grid gap-5 md:grid-cols-3">
              {pdfs.map((pdf, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-md hover:-translate-y-1 transition"
                >
                  <FaFilePdf className="text-red-600 text-3xl mb-3" />
                  <h4 className="text-lg font-semibold mb-2">{pdf.title}</h4>
                  <p className="text-sm text-gray-600 mb-4">{pdf.text}</p>
                  <a
                    href={pdf.file}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-block bg-brand-secondary hover:bg-[#3F8FB6] text-white text-sm px-4 py-2 rounded-md"
                  >
                    View PDF
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default Programmes;